import { initialState } from "./initialState";
import * as types from "./types";

export default function sharedReducer(state = initialState.apiStatus, action) {
  switch (action.type) {
    case types.SET_PARAMETER_SITES_UNIT_OPERATIONS_FILTERS:
      return {
        ...state,
        productSitesUopValues: action.payload,
      };

    default:
      return state;
  }
}
